import { Box } from "@mui/material";

export const DecorativeCorner = ({ sx }) => (
	<Box
		component="img"
		src="/images/mandala.png"
		alt="Decorative corner"
		width="60px"
		height="60px"
		sx={{
			position: "absolute",
			opacity: 0.9,
			...sx,
		}}
	/>
);
